module.exports = __webpack_public_path__ + "img/JannisMaroshek.9fbdd01b.png";